import { render } from "./FileColDisplayBatch.vue?vue&type=template&id=2bc03fba"
import script from "./FileColDisplayBatch.vue?vue&type=script&lang=js"
export * from "./FileColDisplayBatch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__